import React, { Component } from "react";
import EE from "../../../api/eventemitter";

class EditableHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.data.name || "Undefined",
      isEditing: false,
    };
    this.inputRef = React.createRef();
  }

  enableEdit = () => {
    this.setState({ isEditing: true }, () => {
      this.inputRef.current.focus();
    });
  };

  handleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleBlur = () => {
    this.setState({ isEditing: false });
    EE.emit("Update Output",{field:"name",value:this.state.title,index:this.props.data.id})
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.setState({ isEditing: false });
    EE.emit("Update Output",{field:"name",value:this.state.title,index:this.props.data.id})
  };

  render() {
    const { title, isEditing } = this.state;
    const {classes, data} = this.props;

    return (
      <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>

        {/* Title + pencil grouped tightly, constrained so other stuff isn't pushed */}
        <div style={{ display: "flex", alignItems: "center", minWidth: 0, maxWidth: "fit-content" }}>
          {isEditing ? (
            <input
              ref={this.inputRef}
              value={title}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              onKeyDown={this.handleKeyDown}
              style={{
                fontWeight: "700",
                fontSize: "28px",
                border: "none",
                borderBottom: "2px solid #aaa",
                outline: "none",
                background: "transparent",
                padding: "0 2px",
                width: `${Math.max(title.length, 5)}ch`,  // shrinks/grows with text, won't overflow
                maxWidth: "500px",                         // hard cap so it never pushes right-side content
                minWidth: "200px",
              }}
            />
          ) : (
            <h1
              style={{
                margin: 0,
                fontWeight: "700",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "700px",
                fontSize: "28px"
              }}
              className={classes.outputModalGeader}
            >
              {title}
            </h1>
          )}

          <button
            onClick={this.enableEdit}
            aria-label="Edit title"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#aaa",
              padding: "0 0 0 6px",
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            ✏️
          </button>
        </div>

      </div>
    );
  }
}

export default EditableHeader